function Layout({ children }) {
  return (
    <div className="min-h-screen h-auto relative bg-slate-100">{children}</div>
  );
}

export default Layout;
